import { AcademyFetchingClient } from 'academy-common-lib/utils/DataFetchingClient';
const getNewDataFetchingClient = () => new AcademyFetchingClient({
  assumeImmutableResults: true
});
export let dataFetchingClient = getNewDataFetchingClient();
export const reinitialiseDataFetchingClient = async () => {
  dataFetchingClient.stop();
  await dataFetchingClient.clearStore();
  dataFetchingClient = getNewDataFetchingClient();
};